import { Flex } from "@fluentui/react-northstar";
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import CustomBreadCrumb from "../../../../components/breadcrumb";
import { BREADCRUMB_HUMBERGER_GLOBAL } from "../../../../constants/routes/drawer";
import { Container, ContainerFluid } from "../../../../common/styles";
import { NAV_LIST_OFFBOARDING } from "../../constants";
import Step from "../../../addEmployees/components/Step";
import { ROUTES } from "../../../../constants/routes";
import withAuth from "../../../../HOC/withAuth";
import { useStepNumber } from "../../stores/useStepNumber";
import { useUserOffboarding } from "../../hooks/useUserOffboarding";

const OffboardingOutlet = () => {
    const { pathname, state, search } = useLocation();

    const navigate = useNavigate();
    const last_step = useStepNumber((state) => state.last_step);

    // sauvgarder l'id de l'utilisateur reçu dans le state de navigate.
    const { user_offboarding, setUserOffboarding } = useUserOffboarding(
        (state) => state
    );

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ""; // Nécessaire pour certains navigateurs.
        };

        // Ajout de l'événement
        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyage de l'événement
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (state?.id) {
            setUserOffboarding({
                id: state.id,
                key: state.id,
                content: state.job_title,
                email: state.email,
                header: state.full_name,
                image: state.avatar,
            });
        } else if (!user_offboarding?.id) {
            // redirect vers offboarding
            navigate(ROUTES.offboarding.home);
        }
    }, []);

    const current_step =
        NAV_LIST_OFFBOARDING.filter((el) => el.pathname === pathname)[0] ||
        NAV_LIST_OFFBOARDING[0];

    return (
        <Flex fill column styles={{ height: "100vh" }}>
            {/* breadCrumb */}
            <CustomBreadCrumb
                humberger={BREADCRUMB_HUMBERGER_GLOBAL}
                navList={[
                    {
                        label: "Offboarding",
                        href: ROUTES.offboarding.home + search,
                    },
                    {
                        label: "préparer un Offboarding",
                        href: "#",
                    },
                ]}
            />
            {/* left and right side */}
            <Flex
                fill
                styles={{
                    background:
                        "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 81%)",
                }}
            >
                <ContainerFluid>
                    <Container>
                        {/* left side */}
                        <Flex.Item
                            styles={{
                                backgroundColor: "white",
                                maxWidth: "450px",
                                width: "100%",
                            }}
                        >
                            <Flex
                                column
                                styles={{ justifyContent: "space-evenly" }}
                            >
                                <Flex column gap="gap.large">
                                    {NAV_LIST_OFFBOARDING.map((el, index) => {
                                        return (
                                            <Step
                                                label={el.label}
                                                key={index}
                                                id={index + 1}
                                                active={
                                                    el.id === current_step?.id
                                                        ? "true"
                                                        : "false"
                                                }
                                                already={
                                                    last_step >= el?.id
                                                        ? "true"
                                                        : "false"
                                                }
                                                required={el.required}
                                                onClick={(e) => {
                                                    if (last_step >= el?.id) {
                                                        navigate(el?.pathname);
                                                    }
                                                }}
                                            />
                                        );
                                    })}
                                </Flex>
                                <Flex hAlign="center">
                                    {current_step.image}
                                </Flex>
                            </Flex>
                        </Flex.Item>
                        {/* right side */}
                        <Flex
                            styles={{
                                backgroundColor: "#F0F0F0",
                                flex: 3,
                                padding: "40px 80px",
                                height: "fit-content",
                                minHeight: "100%",
                            }}
                            gap="gap.small"
                            column
                        >
                            <Outlet />
                        </Flex>
                    </Container>
                </ContainerFluid>
            </Flex>
        </Flex>
    );
};

export default withAuth(OffboardingOutlet);
